import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ElementTooltip, TextEllipsis } from './style';

class ClickableTooltip extends Component {
  constructor(props) {
    super(props);
    this.position = 0;
    this.state = { bottom: false, visible: false };
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this.tooltip);
    this.position = el.getBoundingClientRect().top;
    this.setPosition();
  }

  setPosition() {
    if (this.position < 50) {
      this.setState({ bottom: true });
    }
  }

  render() {
    const { className, text, width } = this.props;
    const { visible } = this.state;
    return (
      <ElementTooltip
        className={className}
        data-text={text}
        tabIndex={0}
        bottom={this.state.bottom}
        ref={reference => {
          this.tooltip = reference;
        }}
        onClick={() =>
          this.setState({
            visible: !visible
          })
        }
        onBlur={() =>
          this.setState({
            visible: !visible
          })
        }
        isVisible={visible}
      >
        <TextEllipsis width={width}>{text}</TextEllipsis>
      </ElementTooltip>
    );
  }
}

ClickableTooltip.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  width: PropTypes.string
};

export default ClickableTooltip;
